import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from 'react';
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import {pad} from "../../functions/default";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';  
import { TabelleZweiSpalten } from '../Rahmendaten/Tabelle_2sp';
import { TabelleVierSpalten } from '../Rahmendaten/Tabelle_4sp';
function Umsatzstatistik(props) {
  const { t } = useTranslation();
  const {accessToken, client} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [tage, setTage] = useState([]);
  const [monat, setMonat] = useState([]);
  const [jahre, setJahre] = useState([]);
  const [datum, ] = useState(new Date().getFullYear().toString()+'-'+pad(new Date().getMonth()+1,2)+'-'+pad(new Date().getDate(),2));
  const [value,setValue]=useState(2);
  const {showErrorMessage} = useMessage() 
  useEffect(() => {
    setIsLoading(true);
    ladeUmsatz();
    // eslint-disable-next-line
  }, []);
  const ladeUmsatz = () => {
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "UMSTAT",
      "statement": "HOLE_DATEN",
      "date": datum,
    }
    apiRequest('POST', 'daten', payload, headers, employeeCb);
  }
  const employeeCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
        setTage(response.data.tag)
        setMonat(response.data.mon)
        setJahre(response.data.jahre)
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }      
  }
  const ansichtMonate = (month) => {
    return(
    (monat.length>0) ? monat.map((dataObject,count) => {
    return( 
      <div      key={count+"monate"}     >
          <Typography style={{marginTop:"20px"}} color="primary">{dataObject.datum}</Typography>
          <TabelleVierSpalten
          key={count+"Monat"}
          name={"Monat"} 
          marginBottom="30px"
          array={dataObject.jahr}
          überschrift1="Jahr"
          überschrift2="Einmal."
          überschrift3="Lfd."
          überschrift4="Gesamt"/>
       </div>
    );})
      :
    <Typography variant="body1">{t("Keine Dateien für Sie bereitgestellt!")}</Typography>
  );
}
 
  const handleChange = (event, newValue) => {
    setValue(newValue);
    console.log(newValue)
  };
  if (isLoading) {
    return <LoadingComponent />
  }
  return (
    <div>
        <Paper square>
      <Tabs 
        value={value}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        aria-label="auswahl"
        centered
      >
        <Tab value={0} label={t("Tag")}/>
        <Tab value={1} label={t("Monat")}/>
        <Tab value={2} label={t("Jahr")}/>
      </Tabs>
      </Paper>
      {value=== 0 &&
        <div>
              <TabelleZweiSpalten
                name={"Tag"}
                array={tage}
                überschrift1="Datum"
                überschrift2="Betrag"/>
        </div>
      }
      {value=== 1 &&
        <div>
              {ansichtMonate("01")}
        </div>
      }
      {value=== 2 &&
      <div style={{marginTop:"30px"}}>        
        <TabelleVierSpalten           
          array={jahre}
          name={"Jahr"}
          überschrift1="Jahr"
          überschrift2="Einmal"
          überschrift3="Lfd."
          überschrift4="Gesamt"/>
      </div>
      }
    </div>
    );
}
export default Umsatzstatistik;
